<template>
  <div class="dropdown">
    <button class="btn btn-secondary btn-sm dropdown-toggle" :disabled="isTrashed" type="button" :id="dropDownId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="mr-2">{{ bulkMessagesCount }}</span>
    </button>
    <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="dropDownId">
      <a class="dropdown-item" href="#" @click="index"><i class="far fa-list-alt fa-fw"></i> List</a>
<!--      <a class="dropdown-item" href="#" @click="create"><i class="fas fa-calendar-alt"></i> Schedule Text</a>-->
      <a class="dropdown-item" href="#" @click="showQuickMessage"><i class="fas fa-bolt fa-fw"></i> Send Text</a>
      <a class="dropdown-item" href="#" @click="showEmailQuickMessage"><i class="fas fa-envelope fa-fw"></i> Send Email</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    dropDownId() {
      return 'dropDown' + _.get(this.row, 'model.id');
    },

    /**
     * @return {Number}
     */
    bulkMessagesCount() {
      return _.get(this.row.model, 'bulk_messages_count', 0);
    },

    /**
     * @return {string}
     */
    bulkMessagesIndexUrl() {
      return this.row.bulkMessagesIndexUrl;
    },

    /**
     * @return {string}
     */
    bulkMessagesCreateUrl() {
      return this.row.bulkMessagesCreateUrl;
    },

    /**
     * @return {string}
     */
    bulkMessageCreateQuickUrl() {
      return this.row.bulkMessageCreateQuickUrl;
    },

    /**
     * @return {string}
     */
    bulkEmailMessageCreateQuickUrl() {
      return this.row.bulkEmailMessageCreateQuickUrl;
    },

    /**
     * @return {Boolean}
     */
    isTrashed() {
      return this.row.is_trashed;
    },
  },

  methods: {
    /**
     * @emits index-bulk-messages
     */
    index() {
      this.$emit('index-bulk-messages', {row: this.row, url: this.bulkMessagesIndexUrl});
    },

    /**
     * @emits create-bulk-messages
     */
    create() {
      this.$emit('create-bulk-messages', {row: this.row, url: this.bulkMessagesCreateUrl});
    },

    /**
     * @emits show-quick-message
     */
    showQuickMessage() {
      this.$emit('show-quick-message', {row: this.row, url: this.bulkMessageCreateQuickUrl});
    },


    /**
     * @emits create-email-bulk-messages
     */
    showEmailQuickMessage() {
      this.$emit('create-email-bulk-messages', {row: this.row, url: this.bulkEmailMessageCreateQuickUrl});
    },
  },
}
</script>
